import { render, staticRenderFns } from "./EditAutoScaling.vue?vue&type=template&id=15a66460&scoped=true&"
import script from "./EditAutoScaling.vue?vue&type=script&lang=ts&"
export * from "./EditAutoScaling.vue?vue&type=script&lang=ts&"
import style0 from "./EditAutoScaling.vue?vue&type=style&index=0&id=15a66460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a66460",
  null
  
)

export default component.exports